'use strict';
const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'open_ticket',
    viewClass: require('./view'),
    modelClass: require('./model'),
    methods: {
        manageAcceptedFlexibleTicket(pnr) {
            this.openAcceptedOverlay(pnr);
        },
        managePendingFlexibleTicket(pnr) {
            this.openAcceptanceOverlay(pnr);
        },
        openRefundStatus(pnr, notificationManagerScope) {
            this.openAppSplashOverlay(pnr, notificationManagerScope);
        },
        openRedemptionStatus(pnr) {
            if (Odigeo.Utils.isMobile()) {
                this.redirectToRedemptionFlow(pnr);
            } else {
                this.openRedemptionPendingAppOverlay(pnr);
            }
        },
    },
});

